// Utilitaire centralisé pour la gestion des logos d'équipes
// Mapping des noms d'équipes API FFF vers les fichiers locaux

// Fonction pour normaliser les noms de fichiers
function normalizeFileName(str) {
  if (!str) return '';
  return str
    .replaceAll('/', ' ')
    .replace(/\s+/g, ' ')
    .replace(/\.+/g, '.')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

// Dictionnaire de correspondance : Nom API → Nom fichier
const TEAM_NAME_MAPPING = {
  // Noms exacts de l'API FFF → Nom du fichier PNG (sans extension)
  'FEIGNIES AULNOYE EFC': 'FEIGNIES AULNOYE EFC',
  'FEIGNIES-AULNOYE': 'FEIGNIES AULNOYE EFC',
  'FEIGNIES AULNOYE': 'FEIGNIES AULNOYE EFC',
  'EFAFC': 'FEIGNIES AULNOYE EFC',
  
  // Équipes N2 - Poule B
  'FC BORGO': 'FC BORGO',
  'COLMAR SR FA': 'COLMAR FOOTBALL',
  'COLMAR FOOTBALL': 'COLMAR FOOTBALL',
  'EPINAL SAS': 'EPINAL SA',
  'EPINAL SA': 'EPINAL SA',
  'EPINAL': 'EPINAL SA',
  'AS BEAUVAIS OISE': 'AS BEAUVAIS OISE',
  'BEAUVAIS OISE AS': 'AS BEAUVAIS OISE',
  'BEAUVAIS': 'AS BEAUVAIS OISE',
  'BOURGES': 'BOURGES',
  'FURIANI AGLIA': 'FURIANI AGLIA',
  'FURIANI AGLIANI': 'FURIANI AGLIA',
  'CHANTILLY US': 'CHANTILLY US',
  'CHANTILLY': 'CHANTILLY US',
  'WASQUEHAL FOOTBALL': 'WASQUEHAL FOOTBALL',
  'WASQUEHAL': 'WASQUEHAL FOOTBALL',
  'BETHUNE STADE 21': 'BETHUNE STADE 21',
  'BETHUNE': 'BETHUNE STADE 21',
  'AVION CS': 'AVION CS',
  'AVION': 'AVION CS',
  'BIESHEIM A.S.C.': 'BIESHEIM A.S.C.',
  'BIESHEIM ASC': 'BIESHEIM A.S.C.',
  'BIESHEIM': 'BIESHEIM A.S.C.',
  'BLOIS F. 41': 'BLOIS F41',
  'CHAMBLY OISE FC': 'CHAMBLY OISE FC',
  'CHAMBLY': 'CHAMBLY OISE FC',
  'FC 93 BOBIGNY B. G.': 'FC 93 BOBIGNY B. G.',
  'FC 93': 'FC 93 BOBIGNY B. G.',
  'FC FLEURY 91': 'FC FLEURY 91',
  'FLEURY 91': 'FC FLEURY 91',
  'FLEURY-MEROGIS': 'FC FLEURY 91',
  'CRETEIL LUSITANOS F.': 'CRETEIL LUSITANOS F.',
  'CRETEIL': 'CRETEIL LUSITANOS F.',
  'F.C.BALAGNE': 'F.C.BALAGNE',
  'FC BALAGNE': 'F.C.BALAGNE',
  'BALAGNE': 'F.C.BALAGNE',
  'HAGUENAU FCSR': 'HAGUENAU FCSR',
  'HAGUENAU': 'HAGUENAU FCSR',
  'ST PRYVE ST HILAIRE': 'ST PRYVE ST HILAIRE',
  'THIONVILLE US L.': 'THIONVILLE US L.',
  'THIONVILLE': 'THIONVILLE US L.',
  'THIONVILLE LUSITANOS': 'THIONVILLE US L.',
  'AUBERVILLIERS FCM': 'AUBERVILLIERS FCM',
  'AUBERVILLIERS': 'AUBERVILLIERS FCM',
  'AS VILLERS HOULGATE': 'AS VILLERS HOULGATE',
  'VILLERS HOULGATE': 'AS VILLERS HOULGATE',
  'VAFC': 'VAFC',
  'VALENCIENNES': 'VAFC',
};

/**
 * Récupère le logo local d'une équipe
 * @param {string} clubName - Nom de l'équipe (depuis l'API FFF)
 * @returns {string|null} - URL du logo ou null si non trouvé
 */
export const getTeamLogo = (clubName) => {
  if (!clubName) return null;

  // 1. Essayer avec le mapping direct
  const mappedName = TEAM_NAME_MAPPING[clubName];
  if (mappedName) {
    try {
      return require(`../assets/logo_club/${mappedName}.png`);
    } catch (e) {
      // Le fichier mappé n'existe pas, continuer
    }
  }

  // 2. Essayer avec le nom normalisé
  let fileName = normalizeFileName(clubName);
  
  // Cas spécial pour EFAFC
  if (fileName.includes('FEIGNIES') || fileName.includes('AULNOYE') || fileName.includes('EFC')) {
    fileName = 'FEIGNIES AULNOYE EFC';
  }

  try {
    return require(`../assets/logo_club/${fileName}.png`);
  } catch (e) {
    // Aucun logo trouvé
    return null;
  }
};

/**
 * Génère un avatar avec l'initiale de l'équipe
 * @param {string} clubName - Nom de l'équipe
 * @param {object} style - Style personnalisé (couleurs, taille)
 * @returns {object} - Objet avec l'initiale et les classes CSS
 */
export const getTeamInitial = (clubName, style = {}) => {
  const initial = clubName?.charAt(0).toUpperCase() || '?';
  
  const defaultStyle = {
    bgGradientFrom: style.bgGradientFrom || '#FFE400',
    bgGradientTo: style.bgGradientTo || '#BDFF00',
    textColor: style.textColor || '#001B56',
    size: style.size || 'h-8 w-8',
    fontSize: style.fontSize || 'text-xs',
    ...style
  };

  return {
    initial,
    style: defaultStyle
  };
};

/**
 * Vérifie si un logo existe pour une équipe
 * @param {string} clubName - Nom de l'équipe
 * @returns {boolean}
 */
export const hasTeamLogo = (clubName) => {
  return getTeamLogo(clubName) !== null;
};

export default {
  getTeamLogo,
  getTeamInitial,
  hasTeamLogo,
};

